import { MatDialogRef } from '@angular/material/dialog';
import { TransportPlannerProfileDetails, TransportPlannerProfileModel } from '../models';

export class TransportPlannerProfileItemLoad {
  public static readonly type = '[TransportPlannerProfileItem] Load';

  constructor(public payload: number) {}
}

export class TransportPlannerProfileItemCreate {
  public static readonly type = '[TransportPlannerProfileItem] Create';

  constructor(
    public payload: {
      dialog: MatDialogRef<unknown>;
      profile: TransportPlannerProfileModel;
    },
  ) {}
}

export class TransportPlannerProfileItemSave {
  public static readonly type = '[TransportPlannerProfileItem] Save';

  constructor(public payload: TransportPlannerProfileDetails) {}
}

export class TransportPlannerProfileItemUpdate {
  public static readonly type = '[TransportPlannerProfileItem] Update';

  constructor(public payload: TransportPlannerProfileModel) {}
}

export class TransportPlannerProfileItemClone {
  public static readonly type = '[TransportPlannerProfileItem] Clone';

  constructor(public payload: TransportPlannerProfileDetails) {}
}

//TODO: check where it's used
export class TransportPlannerProfileItemDelete {
  public static readonly type = '[TransportPlannerProfileItem] Delete';

  constructor(public payload: { dialog: MatDialogRef<unknown>; profileId: number }) {}
}

export class TransportPlannerProfileItemInitialState {
  public static readonly type = '[TransportPlannerProfileItem] Set Initial State';
}
